import { css, html } from "lit";
import { customElement, state } from "lit/decorators.js";
import { Style } from "../Styles";
import { BaseElement } from "../BaseElement";

import "./ModerationRequest";

import { IModerationRequest } from "../../backend/cloud/ModerationTable";
import orderBy from "lodash-es/orderBy.js";

const MAX_ENTRIES = 64;

@customElement("ds-moderation-list")
export class ModerationList extends BaseElement {
    static override styles = [Style, css``];

    private _moderationTable = this._kernel.dataStore.getSource("moderation-requests");

    @state() protected _requests: IModerationRequest[] | undefined;

    public override async connectedCallback(): Promise<void> {
        super.connectedCallback();
        this._subscribeToKernelEvent("moderation-table-changed", (items: IModerationRequest[]) => {
            this._updateEntries(items);
        });

        this._updateEntries(undefined);
    }
    private async _updateEntries(entries: IModerationRequest[] | undefined) {
        if (entries) {
            this._requests = [...entries];
        } else {
            this._requests = Array.from(await this._moderationTable.all());
        }
        if (this._requests) {
            this._requests = orderBy(this._requests, ["createdAt"], ["desc"]);
            if (this._requests.length > MAX_ENTRIES) {
                this._requests = this._requests.slice(0, MAX_ENTRIES);
            }
        }
    }
    override render() {
        return html`<div class="flex-column">
            ${this._requests?.map((x) => {
                return html`<div>
                    <ds-moderation-request .requestId=${x.id}></ds-moderation-request>
                </div>`;
            })}
        </div>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-moderation-list": ModerationList;
    }
}
